module.exports = __webpack_public_path__ + "static/cube9-f68684152819f91360f64c5fc232cf27.svg";